export const regexpSKU = /^[a-zA-Z0-9_*().s,+/\- ]*$/;
